import React from 'react';
import NoticeDialog from './NoticeDialog';
import { DEMO_LOCKED_MESSAGE } from '../services/demoPolicy';

/**
 * Reusable dialog when a demo user clicks a locked nav item or hits a guarded route.
 */
export default function DemoLockedDialog({ open, onClose, message }) {
  return (
    <NoticeDialog
      open={open}
      title="Demo mode"
      message={message || DEMO_LOCKED_MESSAGE}
      onClose={onClose}
    />
  );
}
